import React, { useEffect, useState } from 'react'
import axiosInstance from '../../utils/axiosInstance';
import { showErrorToast } from '../../utils/toast';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from '../LoadingSpinner';

const AnalyserStatement = () => {
  const [searchParams] = useSearchParams();
  const [documents, setDocuments] = useState({});
  const [loading, setLoading] = useState(true);

  // Get userId and docIndex from URL query parameters
  const userId = searchParams.get('userId');
  const docIndex = searchParams.get('docIndex');

  const fetchDocuments = async () => {
    try {
      const response = await axiosInstance.get(`/user/user-document/${userId}`);
      const res=await axios.get(response.data.data[docIndex]?.bankAnalyzer?.jsonPreSignedUrl)

      setDocuments(res);
      setLoading(false);
    } catch (error) {
      showErrorToast(error?.response?.data?.message)
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchDocuments();
    }
  }, [userId]);
console.log(documents)
  // Now you can use both userId and docIndex
  return (
    <div>
      {loading ? (
        <div><LoadingSpinner /></div>
      ) : (
        <div>
          <p>User ID: {userId}</p>
          <p>Document Index: {docIndex}</p>
        
        </div>
      )}
    </div>
  )
}

export default AnalyserStatement